import { browserSessionPersistence, browserLocalPersistence } from "firebase/auth";
import { auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  updatePassword,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithRedirect
} from "firebase/auth";

export const doSignInWithOrcid = async () => {
  const orcidProvider = new OAuthProvider('oidc.orcid');
  orcidProvider.addScope('openid');
  await signInWithPopup(auth, orcidProvider)
    .catch(() => { });
}

export const doCreateUserWithEmailAndPassword = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailAndPassword = (email, password, rememberme) => {
  if (rememberme) {
    auth.setPersistence(browserLocalPersistence)
    return signInWithEmailAndPassword(auth, email, password)

  } else {
    auth.setPersistence(browserSessionPersistence)
    return signInWithEmailAndPassword(auth, email, password)
  }
};

export const doSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  await signInWithPopup(auth, provider)
    .catch(() => { });
};

export const resetPassword = async (email) => {
  console.log("Resetting password for account " + email.value)
  await sendPasswordResetEmail(auth, email.value);
}

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordReset = (email) => {
  return sendPasswordResetEmail(auth, email);
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

export const doSendEmailVerification = () => {
  return sendEmailVerification(auth.currentUser, {
    url: `https://www.scitility.com/argos`,
  });
};